<template>
<div class="chapter">
<div class="inner_page">
<section>
<div class="imagefp"><span aria-label=" Page i. " epub:type="pagebreak" id="page_i" role="doc-pagebreak"><img alt="Cover: The web of meaning : integrating science and traditional wisdom to find our place in the universe by Jeremy Lent." class="imagefc" role="doc-cover" src="images/cover.jpg"/></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?76ad10a7